import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ACCOMMODATION,
  ACCOMMODATION_CREATE,
  ACCOMMODATION_DELETE,
  ACCOMMODATION_LIST,
  ACCOMMODATION_STUDENT_INFO,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const accommodationSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const accommodationSelector = createSelector(accommodationSelectors, prop(ACCOMMODATION))

export const accommodationCreateSelector = createSelector(accommodationSelectors, prop(ACCOMMODATION_CREATE))

export const accommodationDeleteSelector = createSelector(accommodationSelectors, prop(ACCOMMODATION_DELETE))

export const accommodationListSelector = createSelector(accommodationSelectors, prop(ACCOMMODATION_LIST))

export const accommodationStudentInfoSelector = createSelector(accommodationSelectors, prop(ACCOMMODATION_STUDENT_INFO))
